export default __webpack_public_path__ + "assets/Logo-purple.7906.svg";